import { render, staticRenderFns } from "./Institution.vue?vue&type=template&id=1fe95b99&scoped=true&"
import script from "./Institution.vue?vue&type=script&lang=js&"
export * from "./Institution.vue?vue&type=script&lang=js&"
import style0 from "./Institution.vue?vue&type=style&index=0&id=1fe95b99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe95b99",
  null
  
)

export default component.exports